/*
  Shows the sticky add-to-cart bar on phones while the product form's own
  button is out of view. The observer lives on the element, so a Theme Editor
  reload of the product section disconnects the old one and binds the new one.
*/
if (!customElements.get('alepu-sticky-atc')) {
  customElements.define(
    'alepu-sticky-atc',
    class AlepuStickyAtc extends HTMLElement {
      connectedCallback() {
        const form = document.getElementById(this.dataset.formId);
        const button = form && form.querySelector('[name="add"]');
        if (!button) return;

        this.observer = new IntersectionObserver(([entry]) => {
          const pastButton = !entry.isIntersecting && entry.boundingClientRect.top < 0;
          this.classList.toggle('is-visible', pastButton);
        });
        this.observer.observe(button);
      }

      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
      }
    }
  );
}
